// PUBLICLY AVAILABLE:
import Verify from './pages/Verify/Verify.vue';
import Demo from './pages/Demo.vue';
// import Register from './pages/Register/Register.vue';
import Reset from './pages/TokenReset.vue';
// import Analyze from './pages/Analyze.vue';
import Welcome from './pages/Welcome.vue';
import AnalyzeIntro from './pages/AnalyzeIntro.vue';
import AnalyzeDetails from './pages/AnalyzeDetails.vue';
import AnalyzeAspirations from './pages/AnalyzeAspirations.vue';
import NextSteps from './pages/NextSteps.vue';
import QaAiAssistantTrust from './pages/QaAiAssistantTrust.vue';
// import VerifyExperience from './pages/VerifyExperience/VerifyExperience.vue';
import PublicStatsheet from './pages/PublicStatsheet.vue';
import RejectStatsheet from './pages/RejectStatsheet.vue';
// // import Contact from './components/pages/unauth/Contact.vue';

// // BEHIND AUTH:
import Roster from './pages/Roster/Roster.vue';
import Sales from './pages/Sales.vue';
import RosterConfirmation from './pages/RosterConfirmation.vue';
import Company from './pages/Company.vue';
import BusinessContext from './pages/BusinessContext.vue';
// import ManageWrkr from './pages/ManageWrkr/ManageWrkr.vue';
import Review from './pages/Review.vue';
// import WrkrSearch from './pages/Search/Search.vue';
import Home from './pages/Home.vue';
import AIAssistantHome from './pages/AIAssistantHome.vue';
import CareerPathways from './pages/CareerPathways/CareerPathways.vue';
import Feedback from './pages/Admin/Feedback.vue';
import PsaWorkflowRules from './pages/Admin/PsaWorkflowRules.vue';
import OnboardingData from './pages/Admin/OnboardingData.vue';
import RejectedManVerifications from './pages/Admin/RejectedManVerifications.vue';
import SuperUser from './pages/SuperUser.vue';
import MemberProfile from './pages/MemberProfile.vue';

// // Client UI
// import Client from './components/Client.vue';
// import ClientUser from './components/User/ClientUser.vue';
// // import ClientReport from './components/ClientReport.vue';

// // Admin UI
// import ManageContent from './components/ManageContent.vue';
// import Companies from './components/Companies.vue';
// import Company from './components/Company.vue';
// import Reports from './components/Reports.vue';
// import Report from './components/Report/Report.vue';
// import Users from './components/Users.vue';
// import User from './components/User.vue';

// import Login from './components/pages/unauth/Login.vue';
// import ForgotPassword from './components/pages/unauth/ForgotPassword.vue';
// import PasswordReset from './components/pages/unauth/PasswordReset.vue';

// import NotFound from './components/pages/unauth/NotFound.vue';




const routes = [
    // PUBLICLY AVAILABLE:
    // { path: '/verify-wrkr/:id', component: VerifyExperience },
    {
        path: '/verify',
        name: 'Verify',
        component: Verify,
        meta: { showNav: false },
    },
    {
        path: '/demo',
        name: 'Demo',
        component: Demo,
        meta: { showNav: false },
    },
    // { path: '/register', component: Register },
    { path: '/reset', component: Reset },
    // { path: '/analyze', component: Analyze },
    {
        path: '/welcome/:handle?',
        name: 'Welcome',
        component: Welcome,
        meta: { showNavItems: false }
    },
    {
        path: '/analyze/intro',
        name: 'AnalyzeIntro',
        component: AnalyzeIntro,
        meta: { showNavItems: false }
    },
    {
        path: '/analyze/details',
        name: 'AnalyzeDetails',
        component: AnalyzeDetails,
        meta: { showNavItems: false }
    },
    {
        path: '/analyze/aspirations',
        name: 'AnalyzeAspirations',
        component: AnalyzeAspirations,
        meta: { showNavItems: false }
    },
    {
        path: '/next-steps',
        name: 'NextSteps',
        component: NextSteps,
        meta: { showNavItems: false }
    },
    {
        path: '/profile/:id',
        name: "PublicStatsheet",
        component: PublicStatsheet,
        meta: { hideFeedback: true, showJoin: true }
    },
    { path: '/statsheet/:id', redirect: to => ({ path: `/profile/${to.params.id}`, query: to.query }) },
    { path: '/review/:id', component: Review },
    {
        path: '/reject-profile',
        name: "RejectStatsheet",
        component: RejectStatsheet,
        meta: { showNav: false, hideFeedback: true }
    },
    { path: '/reject-statsheet', redirect: '/reject-profile' },

    // BEHIND AUTH:
    { path: '/', component: AIAssistantHome },
    {
        path: '/last-working-day',
        name: 'LastWorkingDay',
        component: AIAssistantHome,
        props: { autoRunActionId: 'review-last-working-day' },
    },
    {
        path: '/last-working-week',
        name: 'LastWorkingWeek',
        component: AIAssistantHome,
        props: { autoRunActionId: 'review-last-working-week' },
    },
    { path: '/profile', component: Home },
    { path: '/statsheet', redirect: '/profile' },
    { path: '/team', component: Roster },
    { path: '/roster', redirect: '/team' },
    // allowSuperUser: super users manage any company's admins from that company's page
    // (/company?companyId=<id>) — spec-multi-admin-per-company.
    { path: '/company', component: Company, meta: { requiresAdmin: true, allowSuperUser: true } },
    { path: '/company/business-context', component: BusinessContext, meta: { requiresAdmin: true } },
    { path: '/company/psa-workflow-rules', component: PsaWorkflowRules, meta: { requiresAdmin: true } },
    { path: '/sales', component: Sales },
    {
        path: '/team-confirmation',
        name: "RosterConfirmation",
        component: RosterConfirmation,
    },
    { path: '/roster-confirmation', redirect: to => ({ path: '/team-confirmation', query: to.query }) },
    { path: '/career-pathways', component: CareerPathways },
    { path: '/member/:userId', name: 'MemberProfile', component: MemberProfile },

    // SUPER USER
    {
        path: '/superuser',
        name: 'SuperUser',
        component: SuperUser,
        meta: { requiresSuperUser: true },
    },

    // ADMIN
    {
        path: '/admin/feedback',
        name: 'Feedback',
        component: Feedback,
        meta: { requiresAdmin: true }
    },
    {
        path: '/admin/onboarding-data',
        name: 'OnboardingData',
        component: OnboardingData,
        meta: { requiresAdmin: true }
    },
    {
        path: '/admin/rejected-manager-verifications',
        name: 'rejectedManVerifications',
        component: RejectedManVerifications,
        meta: { requiresAdmin: true }
    },


    // { path: '/manage-wrkr', component: ManageWrkr },
    // { path: '/search', component: WrkrSearch },


    // catch all and redirect
    { path: '/:pathMatch(.*)*', redirect: "/welcome" },
    // Custom 404
    // { path: "*", component: NotFound }
];

if (process.env.NODE_ENV !== 'production') {
    routes.splice(routes.length - 1, 0, {
        path: '/qa/ai-assistant-trust',
        name: 'QaAiAssistantTrust',
        component: QaAiAssistantTrust,
        meta: { showNav: false, showNavItems: false }
    });
}

export default routes;
